import { takeLatest } from 'redux-saga/effects';
import {
	getClientListSuccess, getClientListFail,
	getClientDetailsSuccess, getClientDetailsFail,
	getClientTeamListSuccess, getClientTeamListFail,
	getClientTeamDetailsSuccess, getClientTeamDetailsFail,
	getClientUserListSuccess, getClientUserListFail,
	getClientUserDetailsSuccess, getClientUserDetailsFail,
	getClientSettingListSuccess, getClientSettingListFail,
  	getClientSettingDetailsSuccess, getClientSettingDetailsFail,
	doDeleteSupervisorSuccess, doDeleteSupervisorFail
} from './clientState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/workforce/clients');
const systemService = createCrudService('api/v1/system/clients');
const redirectData = {route:'/console/clients', mode: 'list', recordId:0 };
const modelName = 'Client';
const modelId = 'clt_id';

function* getClientList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getClientListSuccess, 
		getClientListFail, null, null, LOADING_MSG);
}

function* getClientDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getClientDetailsSuccess, 
		getClientDetailsFail, null, null, LOADING_MSG);		
}

function* doClientCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getClientDetailsSuccess, 
		getClientDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doClientUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getClientDetailsSuccess, 
		getClientDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doClientDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getClientDetailsSuccess, 
		getClientDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

// for team
function* getClientTeamList(data) {
	const { clientId, ...params } = data.payload;
	const childEndpoint = `${clientId}/client-teams`;
	yield doCrudCall(
		() => crudService.getList(params, childEndpoint), 
		getClientTeamListSuccess, 
		getClientTeamListFail, null, null, LOADING_MSG);
}

function* getClientTeamDetails(data) {
	const { clientId, teamId } = data.payload;
	const childEndpoint = `${clientId}/client-teams`;
	yield doCrudCall(
		() => crudService.getDetails(teamId, childEndpoint), 
		getClientTeamDetailsSuccess, 
		getClientTeamDetailsFail, null, null, LOADING_MSG);		
}

function* doClientTeamCreate(data){
	const cte_client_id = data.payload.cte_client_id;
	const childEndpoint = `${cte_client_id}/client-teams`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint), 
		getClientTeamDetailsSuccess, 
		getClientTeamDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);	
}

function* doClientTeamUpdate(data){
	const { cte_client_id, cte_id } = data.payload;
	const childEndpoint = `${cte_client_id}/client-teams`;
	yield doCrudCall(
		() => crudService.doUpdate(cte_id, data.payload, childEndpoint), 
		getClientTeamDetailsSuccess, 
		getClientTeamDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doClientTeamDelete(data){
	const { cte_client_id, cte_id} = data.payload;
	const childEndpoint = `${cte_client_id}/client-teams`;
	yield doCrudCall(
		() => crudService.doDelete(cte_id, childEndpoint), 
		getClientTeamDetailsSuccess, 
		getClientTeamDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload"},
		DELETING_MSG);	
}

// for users
function* getClientUserList(data) {
	const { clientId, ...params } = data.payload;
	const childEndpoint = `${clientId}/client-users`;
	yield doCrudCall(
		() => crudService.getList(params, childEndpoint), 
		getClientUserListSuccess, 
		getClientUserListFail, null, null, LOADING_MSG);
}

function* getClientUserDetails(data) {
	const { clientId, userId } = data.payload;
	const childEndpoint = `${clientId}/client-users`;
	yield doCrudCall(
		() => crudService.getDetails(userId, childEndpoint), 
		getClientUserDetailsSuccess, 
		getClientUserDetailsFail, null, null, LOADING_MSG);		
}

function* doClientUserCreate(data){
	const clu_client_id = data.payload.clu_client_id;
	const childEndpoint = `${clu_client_id}/client-users`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint), 
		getClientUserDetailsSuccess, 
		getClientUserDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);	
}

function* doClientUserUpdate(data){
	const { clu_client_id, clu_id } = data.payload;
	const childEndpoint = `${clu_client_id}/client-users`;
	yield doCrudCall(
		() => crudService.doUpdate(clu_id, data.payload, childEndpoint), 
		getClientUserDetailsSuccess, 
		getClientUserDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doClientUserDelete(data){
	const { clu_client_id, clu_id} = data.payload;
	const childEndpoint = `${clu_client_id}/client-users`;
	yield doCrudCall(
		() => crudService.doDelete(clu_id, childEndpoint), 
		getClientUserDetailsSuccess, 
		getClientUserDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload"},
		DELETING_MSG);	
}

// for setting
function* getClientSettingList(data) {
	const { parentId, ...params } = data.payload;
	const childEndpoint = `${parentId}/settings`;
	yield doCrudCall(
		() => systemService.getList(params, childEndpoint), 
		getClientSettingListSuccess, 
		getClientSettingListFail, null, null, LOADING_MSG);
}

function* getClientSettingDetails(data) {
	const { clientId, set_id} = data.payload;
	const childEndpoint = `${clientId}/settings`;
	yield doCrudCall(
		() => systemService.getDetails(set_id, childEndpoint), 
		getClientSettingDetailsSuccess, 
		getClientSettingDetailsFail, null, null, LOADING_MSG);		
}


function* doClientSettingUpdate(data){
	const { parentId, settingId } = data.payload
	const childEndpoint = `${parentId}/settings`;
	yield doCrudCall(
		() => systemService.doUpdate(settingId, data.payload, childEndpoint), 
		getClientSettingListSuccess, 
		getClientSettingListFail,
		updateRecordSuccess(modelName),
		null,
		UPDATING_MSG);
}

function* doDeleteSupervisor(data){
	console.log("doDeleteSupervisor");
	const { cte_client_id, cte_id, cts_id } = data.payload;
	const childEndpoint = `${cte_client_id}/client-teams/${cte_id}/client-team-supervisors`;
	yield doCrudCall(
		() => crudService.doDelete(cts_id, childEndpoint), 
		doDeleteSupervisorSuccess, 
		doDeleteSupervisorFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload"},
		DELETING_MSG);
}

function* clientSaga() {
	yield takeLatest('client/getClientList', getClientList);
	yield takeLatest('client/getClientDetails', getClientDetails);
	yield takeLatest('client/doClientCreate', doClientCreate);
	yield takeLatest('client/doClientUpdate', doClientUpdate);
	yield takeLatest('client/doClientDelete', doClientDelete);  
	yield takeLatest('client/getClientTeamList', getClientTeamList);
	yield takeLatest('client/getClientTeamDetails', getClientTeamDetails);
	yield takeLatest('client/doClientTeamCreate', doClientTeamCreate);
	yield takeLatest('client/doClientTeamUpdate', doClientTeamUpdate);
	yield takeLatest('client/doClientTeamDelete', doClientTeamDelete);
	yield takeLatest('client/getClientUserList', getClientUserList);
	yield takeLatest('client/getClientUserDetails', getClientUserDetails);
	yield takeLatest('client/doClientUserCreate', doClientUserCreate);
	yield takeLatest('client/doClientUserUpdate', doClientUserUpdate);
	yield takeLatest('client/doClientUserDelete', doClientUserDelete);
	yield takeLatest('client/getClientSettingList', getClientSettingList);
	yield takeLatest('client/getClientSettingDetails', getClientSettingDetails);
	yield takeLatest('client/doClientSettingUpdate', doClientSettingUpdate);
	yield takeLatest('client/doDeleteSupervisor', doDeleteSupervisor);
}

export default clientSaga;
